export default {
    getProfileInfo(state) {
        return state.profileData;
    },
    getSaveProfile(state) {
        return state.wpProfile;
    },
}